import { Inter } from "next/font/google";
import { useStripeContext } from "@/context/StripeContextProvider";

const inter = Inter({ subsets: ["latin"] });

export default function ChargeInfoBox() {
    const { stripeData } = useStripeContext();
    const { pricePerMonth, withTrial, priceAmount } = stripeData;

    console.log('ChargeInfoBox', {
        pricePerMonth,
        withTrial,
        priceAmount,
    });
    return (
        <div className={`${inter.className} h-fit  
        bg-gradient-dark-porange
        rounded-lg p-0.5
        flex flex-col gap-1.5`}>
            <div className="bg-white p-3 rounded-md bg-gradient-soft-blush">
                <div className="flex justify-between items-center pb-3">
                    <span className="text-[#002551] text-lg font-semibold">Charged today</span>
                    <span className="text-[#002551] text-lg font-semibold">
                        {
                            withTrial ? "$0.00" : `$${priceAmount}`
                        }
                    </span>
                </div>
                <div className="flex flex-col gap-2">
                    {pricePerMonth && <div className="flex justify-between">
                        <span className="text-[#002551] text-[13px] font-semibold">{withTrial ? "Price after 7 days" : ""}</span>
                        <span className="text-[#002551] text-[13px] font-normal">
                            ${pricePerMonth.toFixed(2)}/mo billed annually
                        </span>
                    </div>}
                    {withTrial ? <>
                        <div className="flex justify-between">
                            <span className="text-[#002551] text-[13px] font-semibold">Access Atly maps</span>
                            <span className="text-[#002551] text-[13px] font-bold">Free</span>
                        </div>
                        <span className="text-[#002551] text-[13px] font-normal">No commitment. Cancel anytime</span>
                    </> : null
                    }
                </div>
            </div>
        </div>
    );
}